import { getAddress } from 'viem'

export const getChecksumAddress = (address: string): string => {
    try {
        // Handle empty/null/undefined addresses
        if (!address) return address
        return getAddress(address)
    } catch (err) {
        console.warn('Invalid address format, returning original:', address)
        return address
    }
}

export const isLowerCaseEVMAddress = (address: string | undefined): boolean => {
    if (!address) {
        return false
    } else {
        return /^0x[a-f0-9]{40}$/.test(address)
    }
}

export const isEVMAddress = (address: string | undefined): boolean => {
    if (!address) {
        return false
    } else {
        return /^0x[a-fA-F0-9]{40}$/.test(address)
    }
}
